import React, { ReactNode } from 'react';
import styles from './AuthControls.module.scss';

type AuthControlsProps = {
    children?: ReactNode;
};

export default function AuthControls(props: AuthControlsProps) {
    const { children } = props;
    return <div className={styles.controls}>{children}</div>;
}
